/*
 * biobio-collection.js
 *
 * Web Component <biobio-coupon> — botao de codigo de cupom com copiar para a
 * area de transferencia. Usado no header da section biobio-collection.
 *
 * Markup esperado:
 *   <biobio-coupon data-code="SKINCARE">
 *     <button class="biobio-coupon__code">...</button>
 *     <span class="biobio-coupon__feedback" aria-live="polite"></span>
 *   </biobio-coupon>
 *
 * Feedback visual via classe .is-copied (CSS troca o icone copiar -> check).
 */
(function () {
  'use strict';

  class BiobioCoupon extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.biobio-coupon__code');
      this.feedback = this.querySelector('.biobio-coupon__feedback');
      this.code = (this.dataset.code || '').trim();
      if (!this.button || !this.code) return;
      this._onClick = this.copy.bind(this);
      this.button.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (this.button && this._onClick) {
        this.button.removeEventListener('click', this._onClick);
      }
      clearTimeout(this._timer);
    }

    async copy() {
      let ok = true;
      try {
        await navigator.clipboard.writeText(this.code);
      } catch (err) {
        ok = this.legacyCopy();
      }
      this.flash(ok);
    }

    legacyCopy() {
      try {
        const ta = document.createElement('textarea');
        ta.value = this.code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        ta.remove();
        return ok;
      } catch (err) {
        return false;
      }
    }

    flash(ok) {
      this.classList.toggle('is-copied', ok);
      if (this.feedback) {
        this.feedback.textContent = ok
          ? 'Cupom ' + this.code + ' copiado'
          : 'Copie o cupom: ' + this.code;
      }
      clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        this.classList.remove('is-copied');
        if (this.feedback) this.feedback.textContent = '';
      }, 2400);
    }
  }

  if (!customElements.get('biobio-coupon')) {
    customElements.define('biobio-coupon', BiobioCoupon);
  }
})();
